import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { history } from "../../../store"
import { logPageView } from '../../../utils/emfLogs'
import { Pages } from '../../../utils/loggerConstants'
import { pageLoadLogs } from '../../../utils/loggerUtils'
import employeeService from '../../../services/Employee.service';
import siteContentService from '../../../services/SiteContent.service';
import HelpfulInformation from '../HelpfulInformation';
import PopularActions from './PopularActions';
import VestingSummary from './VestingSummary';
import UnacceptedStockAwards from './UnacceptedStockAwards';
import { setFocusToDashboard } from '../common/common'

import { Col } from '@amzn/stencil-react-components/layout';

export class Dashboard extends Component {
  componentDidMount() {
    logPageView(Pages.Dashboard)
    pageLoadLogs(Pages.Dashboard, this.props.employee)

    if (history.location.state?.fromLogo) {
      setFocusToDashboard();
    }
  }

  render() {
    const { t } = this.props;
    return (
      <Col dataTestId="dashboard" gridGap="S400">
        <UnacceptedStockAwards />
        <VestingSummary />
        <PopularActions />
        {!employeeService.isWholeFoodsEmployee(this.props.employee) && (
          <HelpfulInformation articles={this.props.articles} />
        )}
      </Col>
    );
  }
}

const mapState = (state) => ({
  articles: siteContentService.getHomepageArticles(state.static_content),
  employee: state.employee,
});

export default connect(mapState)(withTranslation('translationsV2')(Dashboard));
